// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import { DndProvider } from "react-dnd";
// import { HTML5Backend } from "react-dnd-html5-backend";
// import { PersistGate } from "redux-persist/integration/react";
// import { Provider } from "react-redux";
// import { persistor, store } from "./components/Store/storeIndex";
// import { GoogleOAuthProvider } from "@react-oauth/google";
// import { BrowserRouter } from "react-router-dom";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <GoogleOAuthProvider
//     // clientId="455429579373-8vd36mf70n6sg8o4ajni8j1r04gf1pbf.apps.googleusercontent.com"
//     clientId="441450293587-lqrh4ptmuh5ekndpspcij64hh4epgmdv.apps.googleusercontent.com"
//     scope="https://www.googleapis.com/auth/youtube.readonly"
//   >
//     <React.StrictMode>
//       <Provider store={store}>
//         <PersistGate loading={null} persistor={persistor}>
//           <DndProvider backend={HTML5Backend}>
//             <App />
//           </DndProvider>
//         </PersistGate>
//       </Provider>
//     </React.StrictMode>
//   </GoogleOAuthProvider>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { DndProvider } from "react-dnd";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";

import { BrowserRouter } from "react-router-dom";
import store from "./app/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
